import Vue from 'vue';

export const itemCRUD = {
  state() {
    return {
      items: [],
      itemsToDelete: [],
    };
  },
  getters: {
    items(state) {
      return state.items.filter(item => !item.delete);
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    addItem(state, data) {
      state.items.push({ ...data });
    },
    editItem(state, data) {
      Vue.set(state.items, data.order || 0, data);

      if (data.order >= 0 && data.id) {
        Vue.set(state.items[data.order || 0], 'update', true);
      }
    },

    deleteItem(state, item) {
      Vue.set(state.items[item.order], 'delete', true);
      if (!item.new) {
        state.itemsToDelete.push(state.items[item.order]);
      }
      state.items = state.items
        .filter(i => !i.delete)
        .map((item, i) => ({
          ...item,
          order: i,
          update: !item.new,
        }));
    },
    clearItems(state) {
      state.itemsToDelete = [];
    },
  },
  actions: {
    addItem({ commit, dispatch }, payload) {
      commit('addItem', payload);
      dispatch('addDirtyTab');
    },

    editItem({ commit, dispatch }, payload) {
      commit('editItem', payload);
      dispatch('addDirtyTab');
    },
    setItems({ commit, dispatch }, payload) {
      commit('setItems', payload);
      dispatch('addDirtyTab');
    },
    deleteItem({ commit, dispatch }, payload) {
      commit('deleteItem', payload);
      dispatch('addDirtyTab');
    },
    clearItems({ commit }) {
      commit('clearItems');
    },
  },
};
